import React, { useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
} from '@mui/material';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";






const SalaryExpectationsForm = ({ onChildData }) => {
  const [salaryExpectations, setSalaryExpectations] = useState({
    salary_range_usd: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSalaryExpectations({ ...salaryExpectations, [name]: value });
    onChildData({ salary_expectations: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const output = `salary_expectations:\n  salary_range_usd: "${salaryExpectations.salary_range_usd}"`;
    
    console.log(output);
    // Process salary expectations as needed
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3,pt:0,pb:2 }}>
      <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
          <Typography variant="h6">Salary Expectations</Typography>
          </AccordionSummary>
          <AccordionDetails>
          <FormControl fullWidth required size='small'>
        <InputLabel id="salary-range-label">Expected Salary Range (USD)</InputLabel>
        <Select
          labelId="salary-range-label"
          name="salary_range_usd"
          
          value={salaryExpectations.salary_range_usd}
          onChange={handleChange}
          label="Expected Salary Range (USD)"
        >
          <MenuItem value="">Select a range</MenuItem>
          <MenuItem value="50000 - 70000">$50,000 - $70,000</MenuItem>
          <MenuItem value="70000 - 90000">$70,000 - $90,000</MenuItem>
          <MenuItem value="90000 - 110000">$90,000 - $110,000</MenuItem>
          <MenuItem value="110000 - 130000">$110,000 - $130,000</MenuItem>
          <MenuItem value="130000 - 150000">$130,000 - $150,000</MenuItem>
          <MenuItem value="150000+">$150,000+</MenuItem>
        </Select>
      </FormControl>
          </AccordionDetails>
        </Accordion>
    
      <Button type="submit" variant="contained" sx={{ mt: 2,display:'none' }}>
        Submit
      </Button>
    </Box>
  );
};

export default SalaryExpectationsForm;